import { PointTooltipProps } from '@nivo/line';
import { TooltipContainer } from '../styled';
import formatDuration from '../helpers/formatDuration';

export const CallLineTooltip = ({ point }: PointTooltipProps) => (
    <TooltipContainer>
        <div>
            <strong>{point.data.xFormatted}</strong>
        </div>
        <div>
            <span>
                {point.serieId}
                {' '}
                calls:
                {' '}
                {point.data.yFormatted}
            </span>
        </div>
    </TooltipContainer>
);

export const MinuteLineTooltip = ({ point }: PointTooltipProps) => (
    <TooltipContainer>
        <div>
            <strong>{point.data.xFormatted}</strong>
        </div>
        <div>
            <span>
                {point.serieId}
                :
                {' '}
                {formatDuration(Number(point.data.yFormatted))}
            </span>
        </div>
    </TooltipContainer>
);

export const HeatmapTooltip = ({ cell }: { cell: { serieId: string, value: number } }) => (
    <TooltipContainer>
        <div>
            <strong>{cell.serieId}</strong>
        </div>
        <div>
            <span>
                {cell.value}
                {' '}
                calls
            </span>
        </div>
    </TooltipContainer>
);
